import { Action, combineReducers, configureStore, ThunkAction } from "@reduxjs/toolkit";

import { CoordinatesState, reducer as coordinatesReducer } from "./coordinatesSlice";
import { CustomCrashesState, reducer as customCrashesReducer } from "./customCrashesSlice";
import { NavState, reducer as navReducer } from "./navSlice";
import { PopoverState, reducer as popoverReducer } from "./popoverSlice";
import { reducer as dataFiltersReducer } from "./dataFilterSlice";
import { LegendState, reducer as legendReducer } from "./legendSlice";
import { MapExtentState, reducer as mapExtentReducer } from "./mapExtentSlice";

const store = configureStore({
	reducer: combineReducers({
		coordinatesState: coordinatesReducer,
		customCrashesState: customCrashesReducer,
		dataFiltersState: dataFiltersReducer,
		navState: navReducer,
		popoverState: popoverReducer,
		legendState: legendReducer,
		mapExtentState: mapExtentReducer,
	}),
	preloadedState: undefined,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			thunk: true,
			immutableCheck: true,
			serializableCheck: true,
		}),
	devTools: import.meta.env.MODE === "development",
});

// The top-level state object
export type ApplicationState = {
	coordinatesState: CoordinatesState;
	customCrashesState: CustomCrashesState;
	dataFiltersState: ReturnType<typeof dataFiltersReducer>;
	navState: NavState;
	popoverState: PopoverState;
	legendState: LegendState;
	mapExtentState: MapExtentState;
};

export type AppDispatch = typeof store.dispatch;
export type AppThunk = ThunkAction<void, ApplicationState, unknown, Action>;
export interface AppThunkAction<TAction> {
	(dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
}

export interface BaseState {
	isBusy: boolean; // use this state to denote the backend is busy with an async process
	errorMessage?: string;
}

export type ThunkApi = {
	state: ApplicationState;
};

export default store;
